module.exports = __webpack_public_path__ + "media/images/area/feature/tohoku/banner/vi-116058c4295c3199856942db50a9bbf8.jpg";